"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = require("react");
var _ = require("./..");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _styles = require("../../styles");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const Topbar = _ref => {
  let {
    pages,
    colorInvert = false,
    isSticky = false
  } = _ref;
  const theme = (0, _styles.useTheme)();
  const [sticky, setSticky] = (0, _react.useState)(isSticky);
  const [isNavOpen, setIsNavOpen] = (0, _react.useState)(false);
  const [activeNavItem, setActiveNavItem] = (0, _react.useState)('home');
  const checkIsSticky = e => {
    const header = document.querySelector('header#header');
    const scrollTop = window.scrollY;
    scrollTop >= 30 ? header.classList.add('is-sticky') : header.classList.remove('is-sticky');
  };
  // Sticky Menu Area
  (0, _react.useEffect)(() => {
    if (sticky) {
      window.addEventListener('scroll', checkIsSticky);
    }
    return () => {
      window.removeEventListener('scroll', checkIsSticky);
    };
  });
  const toggleMobileMenu = () => {
    setIsNavOpen(!isNavOpen);
  };
  const setActiveTab = (e, navName) => {
    e.preventDefault();
    setActiveNavItem(navName);
    document.location.href = $(e.target).attr('href');
  };
  const socialMedia = {
    facebookHandle: "indigenux",
    twitterHandle: "indigenux",
    linkedInHandle: "indigenux",
    instagramHandle: "indigenux"
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("header", {
    id: "header",
    className: "header-effect-shrink",
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: "header-body",
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        className: "header-container container",
        children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
          className: "header-row",
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
            className: "header-column",
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
              className: "header-row",
              children: /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
                className: "header-logo",
                children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_.Link, {
                  href: "/",
                  children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_.CompanyLogo, {
                    theme: "dark",
                    "data-sticky-width": "70",
                    "data-sticky-height": "49",
                    "data-sticky-top": "50",
                    width: "100px",
                    height: "70px"
                  })
                })
              })
            })
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
            className: "header-column justify-content-end",
            children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
              className: "header-row",
              children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
                className: "header-nav header-nav-line header-nav-top-line head722er-nav-top-line-with-border order-2 order-lg-1",
                children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
                  className: "header-nav-main header-nav-main-square header-nav-main-effect-2 header-nav-main-sub-effect-1",
                  children: /*#__PURE__*/(0, _jsxRuntime.jsx)("nav", {
                    className: "collapse animated " + (isNavOpen ? "show fadeInDownShorterPlus" : "fadeInDownShorterPlus"),
                    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("ul", {
                      className: "nav nav-pills",
                      id: "mainNav",
                      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("li", {
                        className: "dropdown",
                        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_.Link, {
                          className: "dropdown-item dropdown-toggle " + (activeNavItem == "" || activeNavItem == 'home' ? "active" : ""),
                          href: "/",
                          onClick: e => {
                            setActiveTab(e, 'home');
                          },
                          children: "Home"
                        })
                      }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("li", {
                        className: "dropdown",
                        children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_.Link, {
                          className: "dropdown-item " + (activeNavItem === 'success' ? "active" : ""),
                          href: "/success",
                          onClick: e => {
                            setActiveTab(e, 'success');
                          },
                          children: ["Success @", /*#__PURE__*/(0, _jsxRuntime.jsx)(_.IndiText, {
                            uxCSSClass: "text-color-tertiary"
                          })]
                        }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("ul", {
                          className: "dropdown-menu",
                          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("li", {
                            children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_.Link, {
                              className: "dropdown-item  " + (activeNavItem === 'innovation' ? "active" : ""),
                              href: "/innovate",
                              onClick: e => {
                                setActiveTab(e, 'innovation');
                              },
                              children: ["Innovation @", /*#__PURE__*/(0, _jsxRuntime.jsx)(_.IndiText, {
                                uxCSSClass: "text-color-secondary"
                              })]
                            })
                          }), /*#__PURE__*/(0, _jsxRuntime.jsx)("li", {
                            children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_.Link, {
                              className: "dropdown-item " + (activeNavItem === 'creative' ? "active" : ""),
                              href: "/creative",
                              onClick: e => {
                                setActiveTab(e, 'creative');
                              },
                              children: ["Creative @", /*#__PURE__*/(0, _jsxRuntime.jsx)(_.IndiText, {
                                uxCSSClass: "text-color-quaternary"
                              })]
                            })
                          })]
                        })]
                      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("li", {
                        className: "dropdown",
                        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_.Link, {
                          className: "dropdown-item " + (activeNavItem === 'services' ? "active" : ""),
                          href: "/services",
                          onClick: e => {
                            setActiveTab(e, 'services');
                          },
                          children: "Services"
                        })
                      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("li", {
                        className: "dropdown",
                        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_.Link, {
                          className: "dropdown-item dropdown-toggle " + (activeNavItem === 'contact' ? "active" : ""),
                          href: "/contact-us",
                          onClick: e => {
                            setActiveTab(e, 'contact');
                          },
                          children: "Contact"
                        })
                      })]
                    })
                  })
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("button", {
                  className: "btn header-btn-collapse-nav",
                  "data-bs-toggle": "collapse",
                  "data-bs-target": ".header-nav-main nav",
                  onClick: toggleMobileMenu,
                  children: /*#__PURE__*/(0, _jsxRuntime.jsx)("i", {
                    className: "fas fa-bars"
                  })
                })]
              }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
                className: "header-nav-features order-1 order-lg-2",
                children: /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
                  className: "header-nav-feature header-nav-features-social-icons d-inline-flex",
                  children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_.SocialMediaNav, {
                    facebookHandle: socialMedia.facebookHandle,
                    twitterHandle: socialMedia.twitterHandle,
                    linkedInHandle: socialMedia.linkedInHandle,
                    instagramHandle: socialMedia.instagramHandle,
                    className: "ms-0 d-none d-sm-block"
                  })
                })
              })]
            })
          })]
        })
      })
    })
  });
};
Topbar.propTypes = {
  onSidebarOpen: _propTypes.default.func,
  colorInvert: _propTypes.default.bool
};
Topbar.defaultProps = {};
var _default = exports.default = Topbar;